import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	onSubmit: () => void;
}

/** The Texting page before setup: a warning banner whose button opens the setup wizard. */
const Component: React.FC<Props> = ({ classes = {}, onSubmit }) => (
	<div className={classes.root} role="status">
		<Icons.AlertTriangle size={16} className={classes.icon} aria-hidden="true" />
		<Mui.Typography className={classes.text}>
			Texting isn't set up. Set up texting to reach drip campaign leads from a dedicated number.
		</Mui.Typography>
		<Mui.Button variant="contained" color="primary" className={classes.button} onClick={onSubmit}>
			Get Started
		</Mui.Button>
	</div>
);

export const OptIn = withStyles(Component, styles);
